import { CommonError } from '../../types';
import {
    FETCH_TRENDING_TICKET_FAILURE,
    FETCH_TRENDING_TICKET_REQUEST,
    FETCH_TRENDING_TICKET_SUCCESS,
} from './constants';
import { TrendingTicketType } from './types';

export interface FetchTrendingTicketRequestAction {
    type: typeof FETCH_TRENDING_TICKET_REQUEST;
}

export interface FetchTrendingTicketSuccessAction {
    type: typeof FETCH_TRENDING_TICKET_SUCCESS;
    payload: TrendingTicketType[];
}

export interface FetchTrendingTicketFailureAction {
    type: typeof FETCH_TRENDING_TICKET_FAILURE;
    payload: CommonError;
}

export type TradingTicketActions =
    | FetchTrendingTicketRequestAction
    | FetchTrendingTicketSuccessAction
    | FetchTrendingTicketFailureAction;

export const fetchTrendingTicketRequest = (): FetchTrendingTicketRequestAction => ({
    type: FETCH_TRENDING_TICKET_REQUEST,
});

export const fetchTrendingTicketSuccess = (trendingTicket: TrendingTicketType[]): FetchTrendingTicketSuccessAction => ({
    type: FETCH_TRENDING_TICKET_SUCCESS,
    payload: trendingTicket,
});

export const fetchTrendingTicketFailure = (error: CommonError): FetchTrendingTicketFailureAction => ({
    type: FETCH_TRENDING_TICKET_FAILURE,
    payload: error,
});
